import { Typography, Button } from '@material-ui/core';
import '../styles/Globales.scss';
import '../styles/Mensaje.scss';

import React, { Component } from 'react';
import ListaProductoResumenComponent from './utils/ListaProductoResumenComponent';
import appStore from '../stores/AppStore';
import ViewConstants from '../utils/ViewConstants';

export default class MensajeFinal extends Component {
  componentDidMount = () => {
    if (appStore.solicitarNuevaPortalidadStore.portaTodosSusProductos()) {
      appStore.generateDataLayer({ eventAction: 'step_7', eventLabel: 'todos_exito' });
    } else {
      appStore.generateDataLayer({ eventAction: 'step_7', eventLabel: 'algunos_exito' });
    }
  };

  formatNumeroSolicitud = (value) => {
    let result = '';
    if (value) {
      result = result + value;
    }

    while (result.length < 10) {
      result = '0' + result;
    }
    return result;
  };

  generarCertificado = () => {
    const solicitudId = appStore.solicitarNuevaPortalidadStore.solicitudId;
    appStore.solicitarNuevaPortalidadStore.generarCertificadoPorId(solicitudId, this.onCertificadoOk, this.onCertificadoFail);
  };

  onCertificadoOk = (pdf) => {
    const link = document.createElement('a');
    link.href = 'data:application/pdf;base64,' + pdf;
    link.setAttribute('download', 'solicitud_portabilidad');
    link.click();
  };

  onVerMisSolicitudes = () => {
    if (appStore.solicitarNuevaPortalidadStore.portaTodosSusProductos()) {
      appStore.generateDataLayer({ eventAction: 'step_7.1', eventLabel: 'todos_exito_ver_solicitudes' });
    } else {
      appStore.generateDataLayer({ eventAction: 'step_7.1', eventLabel: 'algunos_exito_ver_solicitudes' });
    }
    appStore.clearStores();
    appStore.cargarSolicitudesCliente(this.onSolicitudesCargadas, 0);
  };

  onSolicitudesCargadas = () => {
    appStore.changeNavigation(ViewConstants.ETAPA_LISTADO_SOLICITUDES);
  };

  onCertificadoFail = () => {};
  render() {
    const listaProductos = appStore.solicitarNuevaPortalidadStore.bolsaProductos.map((item, index) => {
      return <ListaProductoResumenComponent producto={item} key={index} />;
    });
    return (
      <div className="contenedorPrincipal">
        <Typography className="tituloMensaje">¡Felicidades!</Typography>
        <Typography className="subTituloMensaje">tu solicitud se realizó de forma exitosa</Typography>
        <Typography className="tituloSolicitud">Tu nº de solicitud es:</Typography>
        <Typography className="infomensajeCodigo"> {this.formatNumeroSolicitud(appStore.solicitarNuevaPortalidadStore.solicitudId)}</Typography>
        <Typography className="tituloSolicitud">
          Envíanos tus 3 últimas liquidaciones a <a href="mailto:portabilidad@bancoripley.com">portabilidad@bancoripley.com</a> para realizar una evaluación crediticia.
        </Typography>
        <Typography className="tituloSolicitud">Estos son los productos que solicitaste portar. Te enviaremos el comprobante a tu e-mail.</Typography>
        <div className="listaproductos">{listaProductos}</div>
        <div className="botones btnmensaje">
          <Button id="btnVolver" className="btnRipleyAmarillo btnverComprobante" onClick={this.generarCertificado}>
            <img className="pdf" src={require('../images/pdf.svg')} alt="pfd" />
            ver comprobante
          </Button>
          <Button color="primary" id="btnVerifica" className="btnRipley" onClick={this.onVerMisSolicitudes}>
            Ver mis solicitudes
          </Button>
        </div>
        <div>
          <Typography className="contrasenarut"><strong>La contraseña</strong> para abrir el documento es <strong>tu rut sin puntos ni digito verificador.</strong></Typography>
        </div>
      </div>
    );
  }
}
